import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Cons from '../../isomorphic/cons';
import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';
import moment from 'moment/moment';
import _ from 'lodash';
import WorkflowStepTransitionModel from './workflow-step-transition-model';

@inject('appStore')
@observer
export default class WorkflowStepStateWaitingTransitionModal extends Component {
    constructor() {
        super();

        this.reasonOrder = [];
        const trackChanges = field => {
            if (field.value === true) {
                this.reasonOrder.push(field.name);
            } else {
                _.remove(this.reasonOrder, v => {
                    return v === field.name;
                });
            }
        };
        const fields = [
                {
                    name: 'option1',
                    label: 'Missing contact info',
                    type: 'checkbox',
                    hooks: {
                        onChange: trackChanges,
                    },
                },
                {
                    name: 'option2',
                    label: 'Agent advised to wait',
                    type: 'checkbox',
                    hooks: {
                        onChange: trackChanges,
                    },
                },
                {
                    name: 'option3',
                    label: 'Waiting on Agent response',
                    type: 'checkbox',
                    hooks: {
                        onChange: trackChanges,
                    },
                },
                {
                    name: 'option4',
                    label: 'Waiting on a document',
                    type: 'checkbox',
                    hooks: {
                        onChange: trackChanges,
                    },
                },
                {
                    name: 'option5',
                    label: 'Missing something else',
                    type: 'checkbox',
                    hooks: {
                        onChange: trackChanges,
                    },
                },
                {
                    name: 'reasonText',
                    label: 'reason',
                    rules: 'string|max:280',
                    hooks: {
                        onChange: trackChanges,
                    },
                },
            ],
            plugins = {
                dvr: {
                    package: validatorjs,
                    extend: $validator => {
                        const messages = $validator.getMessages('en');
                        messages.required = 'Please enter a :attribute.';
                        $validator.setMessages('en', messages);
                    },
                },
            };

        this.form = new MobxReactForm(
            { fields },
            {
                plugins,
            }
        );
    }

    onSuccess(form) {
        const reasons = [];
        //TODO:  Code Quality
        _.forEach(form.values(), (value, key) => {
            if (value) {
                if (key === 'reasonText') {
                    return;
                } else if (key === 'option5') {
                    reasons.splice(this.reasonOrder.indexOf('option5'), 0, form.fields.get('reasonText').value);
                } else {
                    reasons.splice(this.reasonOrder.indexOf(key), 0, form.fields.get(key).label);
                }
            }
        });
        const newTransition = new WorkflowStepTransitionModel();

        newTransition.reasons.replace(reasons);
        newTransition.createdOn = moment().format();
        newTransition.status = Cons.transitionTypes.Waiting;

        this.props.saveNewStepTransition(newTransition);
        this.props.hide();
    }

    onError(form) {}

    submitForm(e) {
        this.form.onSubmit(e, {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
    }

    render() {
        const formValues = this.form.values();
        //TODO:  Re-factor. Use mobx forms with ValidatorJS (Too many bugs with validationjs)
        const submitButtonEnabled =
            _.valuesIn(formValues).some(x => x === true) &&
            (!formValues.option5 || (formValues.option5 && formValues.reasonText.length > 0));
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.hide}
                onShow={() => {
                    this.reasonOrder = [];
                    this.form.clear();
                }}
            >
                <Modal.Body>
                    <form className="multiple-reason-form">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                                <div className="form-group">
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" {...this.form.$(`option1`).bind()} />
                                            {this.form.$(`option1`).label}
                                        </label>
                                    </div>
                                    <p className="form-error">{this.form.$(`option1`).error}</p>
                                </div>
                                <div className="form-group">
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" {...this.form.$(`option2`).bind()} />
                                            {this.form.$(`option2`).label}
                                        </label>
                                    </div>
                                    <p className="form-error">{this.form.$(`option2`).error}</p>
                                </div>
                                <div className="form-group">
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" {...this.form.$(`option3`).bind()} />
                                            {this.form.$(`option3`).label}
                                        </label>
                                    </div>
                                    <p className="form-error">{this.form.$(`option3`).error}</p>
                                </div>
                                <div className="form-group">
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" {...this.form.$(`option4`).bind()} />
                                            {this.form.$(`option4`).label}
                                        </label>
                                    </div>
                                    <p className="form-error">{this.form.$(`option4`).error}</p>
                                </div>
                                <div className="form-group">
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" {...this.form.$(`option5`).bind()} />
                                            {this.form.$(`option5`).label}
                                        </label>
                                    </div>
                                    <p className="form-error">{this.form.$(`option5`).error}</p>
                                </div>
                                {this.form.$(`option5`).value ? (
                                    <div className="form-group">
                                        <label htmlFor={this.form.$(`reasonText`).id}>
                                            What else are you waiting on?
                                        </label>
                                        <span
                                            style={{
                                                fontSize: 10,
                                                marginLeft: 10,
                                            }}
                                        >
                                            Maximum 280 characters ( {280 - this.form.$(`reasonText`).value.length}{' '}
                                            remaining)
                                        </span>
                                        <textarea
                                            rows={5}
                                            className="form-control"
                                            {...this.form.$(`reasonText`).bind()}
                                            autoFocus={true}
                                        />
                                        <p className="form-error">{this.form.$(`reasonText`).error}</p>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12">
                        <button
                            className="btn btn-primary pull-right"
                            onClick={this.submitForm.bind(this)}
                            disabled={appStore.workflowStore.isLoading || !submitButtonEnabled}
                        >
                            Mark as Waiting
                        </button>
                        <button
                            type="button"
                            className="btn btn-default pull-right"
                            style={{ marginRight: 10 }}
                            onClick={this.props.hide}
                        >
                            Cancel
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

WorkflowStepStateWaitingTransitionModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/workflow/workflow-step-state-waiting-transition-modal.js